// extracted by mini-css-extract-plugin
export default {"welcome-section":"WelcomeSection_welcome-section__FSkG+"};